var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('router-link',{attrs:{"to":"/plusarticle/1401877913885440"}},[_vm._v("有评论")]),_c('router-link',{attrs:{"to":"/plusarticle/1400227803372288"}},[_vm._v("无评论")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }